import React from 'react'
import { Box } from '@mui/material'
import { Dialog, DialogSheet } from '../../Dialog'
import './ExcelTable.css'

const CHROME_FILE_VIEWER_BG = '#525659'

export interface FileLoaderResult {
  data: ArrayBuffer
  type: string
}

export enum FileViewerMenuAction {
  Download,
  MarkAsContract,
  Delete
}

export interface FileViewerDialogProps {
  open: boolean
  onClose: () => void

  /**
   * The first child of the FileViewerDialog should be the main content of the dialog
   */
  children: React.ReactNode
}

export const FileViewerDialog = ({ open, onClose, children }: FileViewerDialogProps) => {
  const [mainChildren, ...restElems] = React.Children.toArray(children)

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogSheet className="h-full min-w-[340px] t:w-[80vw] max-w-[1440px]">
        <Box className="flex t:flex-row h-full">
          <Box className="flex flex-grow border-none h-full overflow-x-scroll" style={{ backgroundColor: CHROME_FILE_VIEWER_BG }}>
            {mainChildren}
          </Box>

          {restElems}
        </Box>
      </DialogSheet>
    </Dialog>
  )
}
